import { Singleton } from '@/decorators';
import { ApiInstance } from '@/services/http';
import { AuthService } from '.';

/**
 * Auth HTTP Service (Framework Agnostic)
 * 
 * HTTP service with authentication interceptors.
 * Automatically adds Bearer token to requests and handles 401 responses.
 */
@Singleton
export class AuthHttpService extends ApiInstance {
  constructor() {
    super();
    
    // Add auth token to all requests
    this._httpClientService.addRequestInterceptor({
      onFulfilled: (config) => {
        const accessToken = new AuthService().getToken();
        if (accessToken) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${accessToken}`,
          };
        }
        return config;
      },
    });

    // Handle 401 responses (logout and clear persisted store)
    this._httpClientService.addResponseInterceptor({
      onFulfilled: (response) => {
        return response;
      },
      onRejected: async (error) => {
        if ((error as any).response?.status === 401) {
          await new AuthService().logout();
        }
        return Promise.reject(error);
      },
    });
  }

  destroy() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this as any).destroyInstance();
  }
}
